import { ApiError } from '@/shared/api/api-client/api-error';
import { API_AUTH_REGISTRATION_TEAM } from '@/shared/constants/bff-endpoints';


export type RegisterViaInvitePayload = {
    email       : string;
    first_name  : string;
    invite_token: string;
    job_title   : string;
    last_name   : string;
    password    : string;
    phone       : string;
};


/** Регистрирует пользователя по приглашению; при успехе BFF сразу выставляет cookies сессии. */
export async function registerViaInvite (payload: RegisterViaInvitePayload): Promise<void> {
    const res = await fetch(API_AUTH_REGISTRATION_TEAM, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify(payload),
    });

    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new ApiError(res.status, data);
    }
}
